import { useNavigate, useLocation } from "react-router-dom";
import { LayoutDashboard, FilePlus2, FileStack, Building2, ShieldCheck, ArrowLeft, Calculator } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { LOGO_URL } from "@/lib/api";

const NAV = [
  { to: "/quotatore-rc", label: "Dashboard", icon: LayoutDashboard, exact: true },
  { to: "/quotatore-rc/preventivi/nuovo", label: "Nuovo Preventivo", icon: FilePlus2 },
  { to: "/quotatore-rc/preventivi", label: "Storico", icon: FileStack, exact: true },
  { to: "/quotatore-rc/enti", label: "Anagrafica Enti", icon: Building2 },
  { to: "/quotatore-rc/ammissibilita", label: "Ammissibilità", icon: ShieldCheck },
];

export default function RCLayout({ children }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuth();
  const isActive = (i) => (i.exact ? location.pathname === i.to : location.pathname.startsWith(i.to) && location.pathname !== "/quotatore-rc");

  return (
    <div className="min-h-screen bg-stone-50">
      <header className="sticky top-0 z-30 [.suite-shell_&]:top-28 overflow-hidden bg-white border-b border-stone-200">
        <div className="max-w-[1500px] mx-auto px-4 sm:px-6 h-16 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <button data-testid="rc-back-dashboard" onClick={() => navigate("/dashboard")}
              className="flex items-center gap-1.5 text-sm text-stone-500 hover:text-stone-900 px-2 py-1.5 rounded-md hover:bg-stone-100 transition-all">
              <ArrowLeft className="h-4 w-4" /> Suite
            </button>
            <div className="h-5 w-px bg-stone-200" />
            <img src={LOGO_URL} alt="Assietica" className="h-11 w-auto object-contain [.suite-shell_&]:hidden" />
            <div className="hidden sm:flex items-center gap-2 leading-tight">
              <Calculator className="h-4 w-4 text-emerald-600" />
              <div>
                <div className="font-semibold text-stone-900">RC Economia Solidale</div>
                <div className="text-[10px] uppercase tracking-widest text-stone-400">Preventivatore</div>
              </div>
            </div>
          </div>
          <span className="text-xs text-stone-500 hidden md:block" data-testid="rc-current-user">{user?.email}</span>
        </div>
        <nav className="max-w-[1500px] mx-auto px-4 sm:px-6 flex gap-1 overflow-x-auto">
          {NAV.map((n) => {
            const Icon = n.icon; const active = isActive(n);
            return (
              <button key={n.to} data-testid={`rc-nav-${n.label.toLowerCase().replace(/[^a-z]/g, "-")}`} onClick={() => navigate(n.to)}
                className={`flex items-center gap-2 px-3 py-2.5 text-sm border-b-2 transition-all whitespace-nowrap ${active ? "border-emerald-600 text-emerald-600 font-medium" : "border-transparent text-stone-500 hover:text-stone-900"}`}>
                <Icon className="h-4 w-4" /> {n.label}
              </button>
            );
          })}
        </nav>
      </header>
      <main className="max-w-[1500px] mx-auto px-4 sm:px-6 md:px-10 py-8">{children}</main>
    </div>
  );
}
